import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'

import { Editor } from '@tinymce/tinymce-react'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './EditScopeTabQuestions.css'

var Spinner = require('react-spinkit');

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const EditScopeTabQuestions = (
    {
        fetchScopeQuestionsErrorClear,
        errScopeQuestions,

        curScopeTabs,
        curScopeTab,

        isOpen,

        scopeName,
        tabName,

        testData,
        testDetailData,

        saveQuestion,
        saveDetailQuestion,

        onDeleteQuestion,
        confirmDeleteQuestion,
        confirmDeleteQuestionYes,
        confirmDeleteQuestionNo,

        onStartQuestion,
        onStartDetailQuestion,
        onStartViewQuestion,

        onStopQuestion,
        onStopDetailQuestion,
        onStopViewQuestion,

        onEditOptions,

        onInstructionsChange,
        onInstructionsChangeQuestions,

        onAfterOpen,
        onRequestCancel
    }) => (
        <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} style={styling}>
            <CommError error={errScopeQuestions.errorQuestions} onClose={fetchScopeQuestionsErrorClear} />

            <ConfirmModal open={confirmDeleteQuestion} heading={"Delete Tab Question"} msg={"Are you sure you want to delete this Tab Question?"} onNo={confirmDeleteQuestionNo} onYes={confirmDeleteQuestionYes} />

            <div className="edit-scope-tab-questions editpages productManagement">
                <div className="form-group">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-6 heading">
                                <h1>{scopeName} - {tabName} - Questions</h1>
                                <span>Manage your data in the box provided below, click Add to create a new question</span><br />
                                <p onClick={onRequestCancel}><i className="fa fa-arrow-circle-left"></i>Tabs</p>
                            </div>

                            <div className="col-md-6 button-options-container">
                                <button className="btn btn-primary pull-right" id="startquestion" onClick={onStartQuestion}>+ Add Question</button>
                            </div>

                            <div className="row mainheader">
                                <div className="tableWrapper">
                                    {
                                        errScopeQuestions.updatingQuestions ?
                                            <Spinner name='line-spin-fade-loader' />
                                        :
                                            null
                                    }

                                    {
                                        <div className="col-md-12 newquestion">
                                            <p>Question Label:</p>
                                            <input className="newquestion error" id="questionlabel" onChange={testData} />

                                            <p>Question Type:</p>
                                            <select className="newquestion error" id="questiontype" onChange={testData}>
                                                <option>Select</option>
                                                <option value="TB">Text Box</option>
                                                <option value="TA">Text Area</option>
                                                <option value="RTA">Right Text Area</option>
                                                <option value="DT">Date</option>
                                                <option value="HCB">Horizontal Checkbox</option>
                                                <option value="VCB">Vertical Checkbox</option>
                                                <option value="DD">Drop Down</option>
                                                <option value="RB">Radio Button</option>
                                                <option value="LI">Left Side Instructions</option>
                                                <option value="RI">Right Side Instructions</option>
                                            </select>

                                            <div className="newinstructions">
                                                <p>Instructions:</p>
                                                <Editor
                                                    init={
                                                        {
                                                            menubar: false,
                                                            branding: false,
                                                            elementpath: false,
                                                            init_instance_callback: onInstructionsChange,
                                                            plugins: "lists advlist link image textcolor table hr code",
                                                            toolbar: "bold italic underline forecolor backcolor | styleselect numlist bullist | fontselect | fontsizeselect | link image | alignleft aligncenter alignright alignjustify | table hr code"
                                                        }
                                                    }
                                                    apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                                                />
                                            </div>

                                            <p>Question Help Text:</p>
                                            <input className="newquestion" id="questiontext" />

                                            <p>Question Order:</p>
                                            <input className="newquestion error" id="questionorder" onChange={testData} />

                                            <div className="newopts">
                                                <span>Required:</span> <input type="checkbox" id="questionrequired" />
                                            </div>

                                            <div className="newopts">
                                                <span>Active:</span> <input type="checkbox" id="questionactive" />
                                            </div>

                                            <div className="buttons">
                                                <a className="btn btn-default" onClick={onStopQuestion}>Cancel</a>
                                                <button className="btn btn-primary save newquestion" onClick={saveQuestion}>Save</button>
                                            </div>
                                        </div>
                                    }

                                    <table className="lists table table-striped">
                                        <thead>
                                            <tr className="head">
                                                <th id="id">ID</th>
                                                <th id="label">Question Label</th>
                                                <th id="type">Question Type</th>
                                                <th id="order">Order</th>
                                                <th>Active</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                curScopeTabs[curScopeTab].questions ?
                                                    curScopeTabs[curScopeTab].questions.map((question, index) => {
                                                        return ([<tr className="body question" questionindex={index} key={index}>
                                                            <td>{question.questionID}</td>
                                                            <td question={question.questionID} questionindex={index} onClick={onStartViewQuestion}>{question.label}</td>
                                                            <td>
                                                            {
                                                                question.questionType == "TB" ? "Text Box" :
                                                                    question.questionType == "TA" ? "Text Area" :
                                                                        question.questionType == "RTA" ? "Right Text Area" :
                                                                            question.questionType == "DT" ? "Date" :
                                                                                question.questionType == "HCB" ? "Horizontal Checkbox" :
                                                                                    question.questionType == "VCB" ? "Vertical Checkbox" :
                                                                                        question.questionType == "DD" ? "Drop Down" :
                                                                                            question.questionType == "RB" ? "Radio Button" :
                                                                                                question.questionType == "LI" ? "Left Side Instructions" :
                                                                                                    question.questionType == "RI" ? "Right Side Instructions" : null
                                                            }
                                                            </td>
                                                            <td>{question.questionOrder}</td>
                                                            <td>{question.isActive ? "Yes" : "No"}</td>
                                                            <td>
                                                                <OverlayTrigger placement="top" overlay={<Tooltip>Edit Question</Tooltip>}>
                                                                    <i className="fa fa-edit" question={question.questionID} questionindex={index} onClick={onStartDetailQuestion}></i>
                                                                </OverlayTrigger>
                                                                <OverlayTrigger placement="top" overlay={<Tooltip>Delete Question</Tooltip>}>
                                                                    <i className="fa fa-remove" question={question.questionID} onClick={onDeleteQuestion}></i>
                                                                </OverlayTrigger>
                                                                {
                                                                    question.questionType == "HCB" ||
                                                                    question.questionType == "VCB" ||
                                                                    question.questionType == "DD"  ||
                                                                    question.questionType == "RB" ?
                                                                        <span question={question.questionID} questionName={question.label} questionType={question.questionType} questionindex={index} onClick={onEditOptions}>Edit Question Options</span>
                                                                    : null
                                                                }
                                                            </td>
                                                        </tr>,
                                                        <tr className="detail" questionindex={index} key={index}>
                                                            <td>
                                                                <div className="detailcore">
                                                                    <p>Question Label:</p>
                                                                    <input className="detailquestion lbl" questionindex={index} onChange={testDetailData} defval={question.label} defaultValue={question.label} />

                                                                    <p>Question Type:</p>
                                                                    <select className="detailquestion type" questionindex={index} onChange={testDetailData} defval={question.questionType} defaultValue={question.questionType}>
                                                                        <option>Select</option>
                                                                        <option value="TB">Text Box</option>
                                                                        <option value="TA">Text Area</option>
                                                                        <option value="RTA">Right Text Area</option>
                                                                        <option value="DT">Date</option>
                                                                        <option value="HCB">Horizontal Checkbox</option>
                                                                        <option value="VCB">Vertical Checkbox</option>
                                                                        <option value="DD">Drop Down</option>
                                                                        <option value="RB">Radio Button</option>
                                                                        <option value="LI">Left Side Instructions</option>
                                                                        <option value="RI">Right Side Instructions</option>
                                                                    </select>

                                                                    <div className="instructions" questionindex={index} defval={question.instructions}>
                                                                        <p>Instructions:</p>
                                                                        <Editor initialValue={$('<div>').html(question.instructions).text()} 
                                                                            init={
                                                                                {
                                                                                    menubar: false,
                                                                                    branding: false,
                                                                                    elementpath: false,
                                                                                    init_instance_callback: onInstructionsChangeQuestions,
                                                                                    plugins: "lists advlist link image textcolor table hr code",
                                                                                    toolbar: "bold italic underline forecolor backcolor | styleselect numlist bullist | fontselect | fontsizeselect | link image | alignleft aligncenter alignright alignjustify | table hr code"
                                                                                }
                                                                            }
                                                                            apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                                                                        />
                                                                    </div>

                                                                    <p>Question Help Text:</p>
                                                                    <input className="detailquestion help" questionindex={index} defval={question.helpText} defaultValue={question.helpText} />

                                                                    <p>Question Order:</p>
                                                                    <input className="detailquestion order" questionindex={index} onChange={testDetailData} defval={question.questionOrder} defaultValue={question.questionOrder} />

                                                                    <div className="detailopts required" questionindex={index} defval={question.isRequired}>
                                                                        <span>Required:</span> <input className="required" questionindex={index} type="checkbox" defaultChecked={question.isRequired} />
                                                                    </div>

                                                                    <div className="detailopts active" questionindex={index} defval={question.isActive}>
                                                                        <span>Active:</span> <input className="active" questionindex={index} type="checkbox" defaultChecked={question.isActive} />
                                                                    </div>

                                                                    <div className="buttons">
                                                                        <a className="btn btn-default" cancel={index} onClick={onStopDetailQuestion}>Cancel</a>
                                                                        <button className="btn btn-primary save" questionindex={index} question={question.questionID} save={index} onClick={saveDetailQuestion}>Save</button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td className="last"></td>
                                                        </tr>,
                                                        <tr className="view" questionindex={index} key={index}>
                                                            <td>
                                                                <div className="viewelement" questionindex={index}>
                                                                    {
                                                                        question.questionType == "TB" ||
                                                                        question.questionType == "TA" ||
                                                                        question.questionType == "DT" ||
                                                                        question.questionType == "HCB" ||
                                                                        question.questionType == "VCB" ||
                                                                        question.questionType == "DD" ||
                                                                        question.questionType == "RB" ||
                                                                        question.questionType == "LI" ?
                                                                            <label>{question.label}
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{question.helpText}</Tooltip>}>
                                                                                    <i className="fa fa-info-circle"></i>
                                                                                </OverlayTrigger>
                                                                            </label> 
                                                                        : null
                                                                    }
                                                                    <br />
                                                                    {
                                                                        question.questionType == "TB" ?
                                                                            <input readOnly />
                                                                        : null
                                                                    }
                                                                    {
                                                                        question.questionType == "TA" ?
                                                                            <textarea readOnly />
                                                                        : null
                                                                    }
                                                                    {
                                                                        question.questionType == "DT" ?
                                                                            <input className="datetime" readOnly />
                                                                        : null
                                                                    }
                                                                    {
                                                                        question.questionType == "HCB" && question.options ?
                                                                            question.options.map((option, indx) => {
                                                                                return <div className="HCB" key={indx}>
                                                                                    <input type="checkbox" /> <span>{option.optionName}</span>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{option.helpText}</Tooltip>}>
                                                                                        <i className="fa fa-info-circle"></i>
                                                                                    </OverlayTrigger>
                                                                                </div>
                                                                            })
                                                                        : null
                                                                    }
                                                                    {
                                                                        question.questionType == "VCB" && question.options ?
                                                                            question.options.map((option, indx) => {
                                                                                return <div className="VCB" key={indx}>
                                                                                    <input type="checkbox" /> <span>{option.optionName}</span>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{option.helpText}</Tooltip>}>
                                                                                        <i className="fa fa-info-circle"></i>
                                                                                    </OverlayTrigger>
                                                                                </div>
                                                                            })
                                                                         : null
                                                                    }
                                                                    {
                                                                        question.questionType == "DD" && question.options ?
                                                                            <select defaultValue={question.instructions}>
                                                                            {
                                                                                question.options.map((option, index) => {
                                                                                    return <option key={index}>{option.optionName}</option>
                                                                                })
                                                                            }
                                                                            </select>    
                                                                        : null
                                                                    }            
                                                                    {
                                                                        question.questionType == "RB" && question.options ?
                                                                            question.options.map((option, indx) => {
                                                                                return <div className="RB" key={indx}>
                                                                                    <input type="radio" /> <span>{option.optionName}</span>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{option.helpText}</Tooltip>}>
                                                                                        <i className="fa fa-info-circle"></i>
                                                                                    </OverlayTrigger>
                                                                                </div>
                                                                            })
                                                                        : null
                                                                    }
                                                                    {
                                                                        question.questionType == "LI" ?
                                                                            <div className="instructions">
                                                                                <Editor initialValue={$('<div>').html(question.instructions).text()}
                                                                                    init={
                                                                                        {
                                                                                            menubar: false,
                                                                                            branding: false,
                                                                                            elementpath: false,
                                                                                            plugins: "lists advlist link image textcolor table hr code",
                                                                                            toolbar: false
                                                                                        }
                                                                                    }
                                                                                    apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                                                                                />
                                                                            </div>
                                                                        : null
                                                                    }

                                                                    <br />
                                                                    <a className="btn btn-default" cancel={index} onClick={onStopViewQuestion}>Cancel</a>
                                                                </div>
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <div className="viewelement right" questionindex={index}>
                                                                    {
                                                                        question.questionType == "RTA" ||
                                                                            question.questionType == "RI" ?
                                                                            <label>{question.label}
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{question.helpText}</Tooltip>}>
                                                                                    <i className="fa fa-info-circle"></i>
                                                                                </OverlayTrigger>
                                                                            </label>
                                                                        : null
                                                                    }
                                                                    {
                                                                        question.questionType == "RTA" ?
                                                                            <textarea readOnly />
                                                                        : null
                                                                    }
                                                                    {
                                                                        question.questionType == "RI" ?
                                                                            <div className="instructions">
                                                                                <Editor initialValue={$('<div>').html(question.instructions).text()}
                                                                                    init={
                                                                                        {
                                                                                            menubar: false,
                                                                                            branding: false,
                                                                                            elementpath: false,
                                                                                            plugins: "lists advlist link image textcolor table hr code",
                                                                                            toolbar: false
                                                                                        }
                                                                                    }
                                                                                    apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                                                                                />
                                                                            </div>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td></td>
                                                            <td className="last"></td>
                                                        </tr>])
                                                    })
                                                : null
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );

// Modal.setAppElement('body');

export default EditScopeTabQuestions